import {useState} from 'react';
import { BrowserRouter as Router} from 'react-router-dom';
import {AppLocalizationProvider, UserProvider} from '../../contexts';
import Header from '../../components/Header';
import Routes from '../../components/Routes';
import './index.scss';

export default function App() {
  const [state, _setState] = useState({open_drawer: true});
  const setState = (newState) => {
    _setState({...state, ...newState});
  };

  return (
      <div className="app">
        <AppLocalizationProvider>
          <UserProvider>
            <Router>
                <Header onDrawerToggle={()=>{
                  setState({open_drawer: !state.open_drawer});
                }}></Header>
                <Routes openDrawer={state.open_drawer} setOpenDrawer={(open) => setState({open_drawer: open})}></Routes>
            </Router>
          </UserProvider>
        </AppLocalizationProvider>
      </div>
  );
}
